import { Spinner, Tooltip, Caption1 } from '@fluentui/react-components';
import {
  DocumentBulletList24Regular,
  ChevronRight20Regular
} from '@fluentui/react-icons';
import { useSelector, connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { ProviderPriceList } from '../../../models/Entities/ProviderAssociations/PriceLists/ProviderPriceList';
import { AppState } from '../../../redux/reducers';

//styles
import './ProviderPriceList.css';

// functions
import * as ownFunctions from './ProviderPriceListFunctions';

export interface IProps {
  priceList: ProviderPriceList[];
  onSelectPriceList?: (PriceList: ProviderPriceList) => void;
}

export const ProviderPriceListComponent = (props: IProps) => {
  const ListPriceState = useSelector((state: AppState) => state.PriceList);
  const [priceListSelected, setPriceListSelected] = useState<ProviderPriceList>();

  const [t] = useTranslation();

  const onSelectListHandler = (list: ProviderPriceList) => {
    setPriceListSelected(list);
    if (props.onSelectPriceList) props.onSelectPriceList(list);
  };

  useEffect(() => {
    if (!priceListSelected) {
      return;
    }

    const updatedSelected = props.priceList.find(
      (item) => item.id === priceListSelected.id
    );

    if (updatedSelected) {
      setPriceListSelected(updatedSelected);
    }
  }, [props.priceList, priceListSelected?.id]);

  if (ListPriceState?.isLoadingAll) {
    return (
      <div className="priceListCardList-loading">
        <Spinner
          size="medium"
          label={t('providerPriceList.loadingBlock.loading')}
        />
      </div>
    );
  }

  if (!props.priceList || props.priceList.length === 0) {
    return (
      <div className="priceListCardList-empty">
        {t('providerPriceList.loadingBlock.noPriceList')}
      </div>
    );
  }

  return (
    <ul className="priceListCardList">
      {props.priceList.map((item) => {
        const isSelected = item.id === priceListSelected?.id;
        const status = ownFunctions.GetPriceListStatus(item);
        const statusLabel = t(status.i18nKey);

        return (
          <li key={item.id} style={{ listStyle: 'none' }}>
            <button
              type="button"
              onClick={() => onSelectListHandler(item)}
              className={`priceListCard${isSelected ? ' selected' : ''}`}
            >
              <div className="priceListCard-iconWrap">
                <DocumentBulletList24Regular />
              </div>
              <div className="priceListCard-body">
                <Tooltip
                  content={item.priceList.listName}
                  relationship="label"
                  withArrow
                >
                  <div className="priceListCard-title">
                    {item.priceList.listName}
                  </div>
                </Tooltip>
                <Caption1
                  className={`priceListTag pricelist ${status.status}`}
                >
                  {statusLabel}
                </Caption1>
              </div>
              <div className="priceListCard-chevron" aria-hidden="true">
                <ChevronRight20Regular />
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default connect(
  ownFunctions.mapStateToProps,
  ownFunctions.mapDispatchToProps
)(ProviderPriceListComponent as any);
